'use client';

import { BlogI18n } from '@/lib/i18n/blogI18n';
import SortButton from '@/features/blog/listing/SortButton';

const BlogSearchBar = ({
  query,
  sort,
  t,
  onQueryChange,
  onSortDesc,
  onSortAsc,
}: BlogSearchBarProps) => (
  <div className="flex flex-col tablet:flex-row gap-3 tablet:gap-4 tablet:items-center mb-2">
    <div className="relative flex-1">
      <input
        type="search"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder={t.searchPlaceholder}
        aria-label={t.searchPlaceholder}
        className="w-full px-4 py-3 pr-10 rounded-xs border border-primary bg-transparent text-form-input font-semibold text-text placeholder:text-text-secondary placeholder:font-normal focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:border-primary transition-colors [&::-webkit-search-cancel-button]:hidden"
      />
      {query && (
        <button
          onClick={() => onQueryChange('')}
          className="absolute right-1 top-1/2 -translate-y-1/2 size-10 flex items-center justify-center text-text-secondary hover:text-text transition-colors cursor-pointer"
          aria-label={t.clearSearch}
        >
          ✕
        </button>
      )}
    </div>
    <div className="flex items-center gap-3 shrink-0">
      <SortButton active={sort === 'desc'} onClick={onSortDesc}>
        {t.sortNewest}
      </SortButton>
      <span className="text-text-secondary text-nav-item">/</span>
      <SortButton active={sort === 'asc'} onClick={onSortAsc}>
        {t.sortOldest}
      </SortButton>
    </div>
  </div>
);

export default BlogSearchBar;

type BlogSearchBarProps = {
  query: string;
  sort: 'asc' | 'desc';
  t: BlogI18n;
  onQueryChange: (value: string) => void;
  onSortDesc: () => void;
  onSortAsc: () => void;
};
